import React from 'react';

// The inline search pill used by the collection pages (Playlists, Likes,
// Favourite Artists): a glass, the input, and a clear button once there is
// text. Escape clears the query before anything upstream reads it as "close
// this view" — hidden rows must never outlive the box that hid them.
const SidebarSearchField = ({ value, onChange, placeholder, ariaLabel }) => (
    <div className="sidebar-search-field">
        <svg className="ssf-glass" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <circle cx="11" cy="11" r="7" />
            <path d="M21 21l-4.2-4.2" />
        </svg>
        <input
            type="text"
            className="ssf-input"
            value={value}
            onChange={(e) => onChange(e.target.value)}
            placeholder={placeholder}
            aria-label={ariaLabel || placeholder}
            onKeyDown={(e) => {
                if (e.key === 'Escape' && value) {
                    e.preventDefault();
                    e.stopPropagation();
                    onChange('');
                }
            }}
        />
        {!!value && (
            <button
                type="button"
                className="ssf-clear"
                onClick={() => onChange('')}
                title="Clear search"
                aria-label="Clear search"
            >
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" aria-hidden="true">
                    <path d="M6 6l12 12M18 6L6 18" />
                </svg>
            </button>
        )}
    </div>
);

export default SidebarSearchField;
